import { Library, Globe, FileText, HelpCircle, ListChecks, type LucideIcon } from 'lucide-react';

interface KnowledgeNavBarProps {
  activeTab: string;
  handleTabChange: (value: string) => void;
}

const tabs: { id: string; label: string; icon: LucideIcon }[] = [
  { id: 'websites', label: 'Websites', icon: Globe },
  { id: 'documents', label: 'Documents', icon: FileText },
  { id: 'questions', label: 'Questions', icon: HelpCircle },
  { id: 'task-definitions', label: 'Task Definitions', icon: ListChecks },
];

const KnowledgeNavBar = ({ activeTab, handleTabChange }: KnowledgeNavBarProps) => {
  return (
    <div className="w-56 border-r h-full bg-background flex-shrink-0">
      <div className="flex h-full flex-col px-3 py-6">
        <h2 className="mb-3 flex items-center gap-2.5 px-3 text-sm font-semibold text-foreground">
          <Library className="size-4 shrink-0 opacity-70" strokeWidth={1.75} />
          Knowledge Base
        </h2>

        <nav className="flex flex-col gap-0.5">
          {tabs.map(({ id, label, icon: Icon }) => {
            const active = activeTab === id;
            return (
              <button
                key={id}
                type="button"
                onClick={() => handleTabChange(id)}
                className={`flex w-full items-center gap-2.5 rounded-md px-3 py-1.5 text-left text-[13px] font-medium transition-colors ${
                  active
                    ? 'bg-accent text-accent-foreground'
                    : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground'
                }`}
              >
                <Icon className="size-4 shrink-0 opacity-70" strokeWidth={1.75} />
                {label}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default KnowledgeNavBar;
